<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field v-if="hasGroupPlants" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in groupPlants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <b-field label="" grouped>
            <b-field label="Stored Types">
              <multiselect
                v-model="targetStock.types"
                :options="types"
                :multiple="true"
                :close-on-select="false"
                placeholder="Pick Types"
                :custom-label="(obj) => obj.name"
                track-by="name"
                style="min-width: 400px;"
                :disabled="isLoading || !isLoaded"
              />
            </b-field>
            <b-field label="Target Reject %">
              <b-input v-model="targetStock.target_reject" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Daily Truck Slots" message="Trucks that can be loaded/unloaded per day. Leave empty for no limit.">
              <b-input
                v-model="targetStock.daily_slot_limit"
                type="number"
                min="0"
                step="1"
                :disabled="isLoading || !isLoaded"
              />
            </b-field>
            <b-field label="Maritime Delay (days)" message="Port operation days added to inbound sea shipments in the forecast.">
              <b-input
                v-model="targetStock.maritime_delay"
                type="number"
                min="0"
                step="1"
                :disabled="isLoading || !isLoaded"
              />
            </b-field>
          </b-field>
          <b-field label="Maximum Stocks" grouped>
            <b-field label="Clean Stock">
              <b-input v-model="targetStock.max_clean" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Total stock">
              <b-input v-model="targetStock.max_total" type="number" :disabled="isLoading || !isLoaded" />
            </b-field>
          </b-field>
          <b-field label="Safety Stocks" grouped>
            <b-field label="Repair Stock">
              <b-input v-model="targetStock.min_repair" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Dirty Stock">
              <b-input v-model="targetStock.min_dirty" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Clean Stock">
              <b-input v-model="targetStock.min_clean" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <b-field label="Available Stock">
              <b-input v-model="targetStock.min_available" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field>
            <!-- <b-field label="Maximum Dirty Stock">
              <b-input v-model="targetStock.max_dirty" type="number" step="0.01" :disabled="isLoading || !isLoaded" />
            </b-field> -->
          </b-field>
          <b-button
            type="is-success"
            icon-left="save"
            :disabled="isLoading || !isLoaded"
            @click="() => {saveTarget();}"
          >
            Save
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TargetStock from '../../services/v3/targetStock'
import plantSelector from '@/mixins/plantSelector'
import { restoreConsultingPlant } from '@/helpers/plants'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'TargetStock',
  components: {
  },
  mixins: [plantSelector],
  data: function () {
    return {
      selectedPlant: restoreConsultingPlant(),
      isLoading: false,
      isLoaded: false,
      storedPlantId: null,
      types: [{ name: '1' }, { name: '1R' }, { name: '1RB' }, { name: '5.1' }, { name: '5.2' }, { name: '5.5' }, { name: '5.X' }, { name: '7.1' }, { name: '7.2' }, { name: 'LIDS' }, { name: 'GPSFood' }, { name: 'ZEON' }, { name: 'RHODIA' }],
      targetStock: {
        max_dirty: 0,
        min_dirty: 0,
        max_clean: 0,
        min_clean: 0,
        max_total: 0,
        min_repair: 0,
        min_available: 0,
        target_reject: 0,
        daily_slot_limit: null,
        maritime_delay: 0,
        types: []
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    await this.loadPlants()
  },
  methods: {
    resetData () {
      this.storedPlantId = null
      this.targetStock = {
        max_dirty: 0,
        min_dirty: 0,
        max_clean: 0,
        min_clean: 0,
        max_total: 0,
        min_repair: 0,
        min_available: 0,
        target_reject: 0,
        daily_slot_limit: null,
        maritime_delay: 0,
        types: []
      }
    },
    async getData () {
      if (!this.selectedPlant || !this.selectedPlant.id) {
        this.$buefy.toast.open({ message: 'Please select a plant', duration: 3000, type: 'is-danger' })
        return
      }
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      try {
        const data = await TargetStock.get({
          id_site: this.selectedPlant.id
        })
        if (data.length > 0) {
          this.targetStock = {
            id: data[0].id,
            id_site: this.selectedPlant.id,
            max_dirty: data[0].max_dirty,
            min_dirty: data[0].min_dirty,
            max_clean: data[0].max_clean,
            min_clean: data[0].min_clean,
            max_total: data[0].max_total,
            min_repair: data[0].min_repair,
            min_available: data[0].min_available,
            target_reject: data[0].target_reject,
            daily_slot_limit: data[0].daily_slot_limit,
            maritime_delay: data[0].maritime_delay ?? 0,
            types: JSON.parse(data[0].types)
          }
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.targetStock = {
            id_site: this.selectedPlant.id,
            max_dirty: 0,
            min_dirty: 0,
            max_clean: 0,
            min_clean: 0,
            max_total: 0,
            min_repair: 0,
            min_available: 0,
            target_reject: 0,
            daily_slot_limit: null,
            maritime_delay: 0,
            types: []
          }
          this.$buefy.toast.open({ message: 'No Data found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.storedPlantId = this.selectedPlant.id
      this.isLoaded = true
      this.isLoading = false
    },
    async saveTarget () {
      const maritimeDelay = this.targetStock.maritime_delay
      if (maritimeDelay !== '' && maritimeDelay != null && !/^\d+$/.test(String(maritimeDelay))) {
        this.$buefy.toast.open({ message: 'Maritime delay must be a whole number of days, 0 or more', duration: 3000, type: 'is-danger' })
        return
      }
      try {
        await TargetStock.saveTargets({
          id: this.targetStock.id,
          id_site: this.targetStock.id_site,
          max_dirty: this.targetStock.max_dirty,
          min_dirty: this.targetStock.min_dirty,
          max_clean: this.targetStock.max_clean,
          min_clean: this.targetStock.min_clean,
          max_total: this.targetStock.max_total,
          min_repair: this.targetStock.min_repair,
          min_available: this.targetStock.min_available,
          target_reject: this.targetStock.target_reject,
          daily_slot_limit: this.targetStock.daily_slot_limit,
          maritime_delay: maritimeDelay === '' || maritimeDelay == null ? 0 : maritimeDelay,
          types: JSON.stringify(this.targetStock.types)
        })
        this.$buefy.toast.open({ message: 'Saved', duration: 3000, type: 'is-success' })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
